import Vue from "vue";
import store from "./store";
import axios from "./modules/axios";
import router from "./modules/router";

import "normalize.css";
import "./modules/gtm";
import "./modules/notify";
import "./modules/globals";
import "./style/index.scss";
import "./modules/object-fit";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

import app from "./app.vue";


(async() => {
	await store.dispatch("config/data");

	new Vue({
		el: "#app",
		store, router,
		render: h => h(app)
	});
})();
